// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTimeline } from '@components/Timeline/Timeline/TimelineProvider';

// TYPES ---------------------------------------------------------------- //

export interface TimelineAreaRowProps {
  dataItem: any;
  index: number;
  isLastItem?: boolean;
}

// COMPONENT ---------------------------------------------------------------- //

const TimelineAreaRow = ({ dataItem, index, isLastItem = false }: TimelineAreaRowProps) => {
  const { componentAreaRow: ComponentAreaRow, componentAreaRowProps, rowSize, timezoneOverride, zoom } = useTimeline();

  if (ComponentAreaRow) {
    // Extract functions from props that need dataItem
    const { isSelected, onClick, ...otherProps } = componentAreaRowProps || {};

    return (
      <ComponentAreaRow
        {...otherProps}
        dataItem={dataItem}
        index={index}
        isLastItem={isLastItem}
        rowSize={rowSize}
        timezoneOverride={timezoneOverride}
        zoom={zoom}
        isSelected={typeof isSelected === 'function' ? isSelected(dataItem) : isSelected}
        onClick={typeof onClick === 'function' ? () => onClick(dataItem) : onClick}
      />
    );
  }
  return null;
};

// -------------------------------- EXPORT -------------------------------- //

export default TimelineAreaRow;
